import * as React from 'react';
import { useIntl } from 'react-intl';
import { CmdModal } from '@commander-services/gui-components';
import { PeriodLockDefinitionRecord } from '../interfaces';
import useAnalytics from '../../../hooks/useAnalytics';
import { getTableName } from '../../CmdTable/CmdTableService';
import { PERIOD_LOCK_DEFINITION_TABLE_KEY } from '../constants';

interface ChipsCellWithModalProps {
  data: PeriodLockDefinitionRecord;
  align?: string;
}

function ChipsCellWithModal({ data, align = 'center' }: ChipsCellWithModalProps) {
  const { formatMessage: f } = useIntl();
  const [isOpenModal, setIsOpenModal] = React.useState(false);
  const { trackEvent } = useAnalytics();

  const handleOpenModal = (event) => {
    event.preventDefault();
    trackEvent([`table ${getTableName(PERIOD_LOCK_DEFINITION_TABLE_KEY)}`, 'click', 'Open modal']);

    setIsOpenModal(true);
  };
  const handleClose = () => {
    trackEvent([`table ${getTableName(PERIOD_LOCK_DEFINITION_TABLE_KEY)}`, 'click', 'Close modal']);
    setIsOpenModal(false);
  };

  return (
    <>
      {isOpenModal && (
        <CmdModal
          id={`chips-table-lockAfter-${data.id}-modal`}
          title={f({ id: `periodLock.lockAfterType` })}
          width="400px"
          footerButtons={[
            {
              id: 'tableTdModalBtn',
              type: 'button',
              title: f({ id: 'form.close' }),
              className: 'e-button',
              closeCallback: handleClose,
            },
          ]}
          usePortal
        >
          <div style={{ margin: '-24px -24px -12px -24px' }}>
            {data.lockAfterPeriods.map((item: string, key: number) => {
              return (
                <div
                  style={{
                    padding: '10px 32px',
                    color: '#555',
                    background: key % 2 ? '#f0f0f0' : '',
                  }}
                  key={item}
                >
                  {item}
                </div>
              );
            })}
          </div>
        </CmdModal>
      )}
      <div
        className={`text-cell align-${align}`}
        style={{ flex: 1, cursor: 'pointer' }}
        data-cy={`chips-table-lockAfter-${data.id}`}
        onClick={handleOpenModal}
        key={data.id}
      >
        <div className="e-table-label">
          {/* <i className={`cmd-icon ${handleIconClass(data)}`} /> */}
          {f({ id: 'periodLock.accordingToPeriod' })}
        </div>
      </div>
    </>
  );
}

export default ChipsCellWithModal;
